import React, { Component } from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleDoc from "../../../../modules/SimpleDoc";
import {
  checkAndHandleError,
  fetchDataAsync,
} from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import * as R from "ramda";
import { HttpStatus } from "../../../common/Constants";

class MasterServiceUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      warningModalVisible: false,
      warningMessage: null,
      typeWarning: null,
    };
  }

  handleDownloadTemplate = async () => {
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA_FILE")
        .masterServiceDownloadExcel,
      menuName: "Upload Master Jasa",
      setError: this.props.setError,
      args: null,
    });
    if (res.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "TEMPLATE_MASTER_JASA.xlsx";
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  };

  changeInput = (fileName, file) => {
    if (file) {
      this.setState((prevValue) => ({ ...prevValue, data: file }));
    }
  };

  handleSubmit = async () => {
    const file = this.state.data;
    this.props.triggerLoading();
    const renamedFile = new File([file], "TEMPLATE_MASTER_JASA.xlsx", {
      type: file.type,
    });
    const formData = new FormData();
    formData.append("file", renamedFile);
    let res = await Api.create("NAGAMAS_MASTER_DATA").masterServiceUploadExcel(
      formData
    );
    this.props.triggerLoading();
    const component = document.getElementById("inputFile");
    if (component && component.value) {
      component.value = "";
    }
    if (res.ok && R.equals(res.data.status, HttpStatus.SUCCESS)) {
      this.props.onSuccessUpload();
    }
    if (res.data.message.includes("Terdapat kesalahan pengisian")) {
      return this.handleWarningModalVisibility(
        "Terdapat kesalahan pengisian data upload. Mohon diperbaiki dan upload kembali kemudian."
      );
    }
    if (res.data.status === "F") {
      return this.props.setError({
        menuName: "Master Jasa Upload",
        errorMessage: res.data.message,
      });
    }
  };

  downloadLogError = async () => {
    try {
      const res = await Api.create(
        "NAGAMAS_MASTER_DATA_FILE"
      ).masterServiceDownloadLogError();
      if (res.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Master_Jasa_Log_Error.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  handleWarningModalVisibility = (text, typeWarning) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      typeWarning: R.isNil(typeWarning) ? 1 : typeWarning,
      warningModalVisible: !prevState.warningModalVisible,
    }));
  };

  render() {
    return (
      <>
        <SimpleModal
          title="Upload Master Jasa"
          visible={this.props.visible}
          onClickClose={this.props.onClickClose}
          styles={{ width: "50%" }}
          content={
            <ModalContainer>
              <FlexView vAlignContent="center">
                <div className="margin-5px">
                  <div className="txt-site txt-11 txt-main txt-bold">
                    <h4>Template file dapat diunduh</h4>
                  </div>
                </div>
                <SimpleButton
                  text="DISINI"
                  onClick={this.handleDownloadTemplate}
                  className="margin-top-5px"
                />
              </FlexView>

              <FlexView
                vAlignContent="center"
                className="margin-bottom-20px margin-top-20px"
              >
                <SimpleDoc
                  readOnly
                  idInputFile="inputFile"
                  onChange={this.changeInput}
                />
              </FlexView>

              <FlexView
                hAlignContent="right"
                className="margin-bottom-20px margin-top-20px"
              >
                <SimpleButton
                  styles={{ width: "250px" }}
                  onClick={this.handleSubmit}
                  disabled={this.state.data.length === 0}
                >
                  Validasi & Upload File
                </SimpleButton>
              </FlexView>
              {this.state.warningModalVisible && (
                <SimpleAlert
                  title={"Information"}
                  content={
                    <div>
                      <p>
                        {this.state.warningMessage}
                        <br />
                        Mohon periksa kembali.
                      </p>
                    </div>
                  }
                  visible={this.state.warningModalVisible}
                  onClickClose={this.handleWarningModalVisibility}
                  additionalButtons={
                    <FlexView
                      vAlignContent={"center"}
                      style={{ justifyContent: "end", gap: "20px" }}
                    >
                      <SimpleButton
                        type="button"
                        text="Tutup"
                        onClick={() => this.handleWarningModalVisibility()}
                      />

                      {R.equals(this.state.typeWarning, 1) && (
                        <SimpleButton
                          type="button"
                          text="Download Log Error"
                          onClick={() => this.downloadLogError()}
                        />
                      )}
                    </FlexView>
                  }
                />
              )}
            </ModalContainer>
          }
        />
      </>
    );
  }
}

export default MasterServiceUpload;
